import dynamic from "next/dynamic";
const CarouselSelectableProductCardsGridComponent = dynamic(()=>import("./carousel-selectable-product-cards-grid-component"));
import CarouselSelectableProductCardsGridConfig from "./carousel-selectable-product-cards-grid-config";
import CarouselSelectableProductCardsGridAdvancedConfig from "./carousel-selectable-product-cards-grid-advanced-config";
export default {
    CarouselSelectableProductCardsGridComponent,
    CarouselSelectableProductCardsGridConfig,
    CarouselSelectableProductCardsGridAdvancedConfig
};
